import { IInteractionsConfig } from '../modules/interactions/types'
import { ILocaleDict } from '../modules/locale/types'
import { IPreviewModuleChangeQuota, IPreviewModuleJumpToQuestion, IPreviewModuleLocale } from '../modules/preview/types'
import { IWidgetStyle } from '../modules/theme/types'
import { ITimelineDurations, ITimelineEvent } from '../modules/timeline/types'
import {
  IQuestionModel,
  IQuestionSchema,
  QuestionID,
  QuestionSubmitResponse,
  QuestionCheckResponse
} from '../questions/types'
import { IImageAsset } from '@aytm/app/swidget/base/modules/images/types'
import { ISessionUrls } from '@aytm/app/swidget/base/session/types'

export enum ActionType {
  ASK = 'ask',
  SHOW = 'show',
  LOAD = 'load',
  REDIRECT = 'redirect',
  END = 'end',
  EXIT = 'exit',
  GDPR = 'gdpr',
  LOADER = 'loader',
  ERROR = 'error'
}

export enum SurveyMode {
  RESPONDENT = 'respondent',
  RESEARCHER = 'researcher',
  XRAYS = 'xrays',
  // Bridge draft-preview: jump to any question, then continue in the real respondent order. URL-only, no toolbar.
  BRIDGE = 'bridge'
}

export interface IActionRulesSubLogicStatementValue {
  condition?: boolean
  text?: string
  image?: IImageAsset
  text_variable?: string
  invalid?: boolean
  variables?: {
    [key: string]: string | boolean | number
  }
}
export interface IActionRulesSubLogicStatements {
  [logicStatement: string]: IActionRulesSubLogicStatementValue
}

export interface IActionRulesSub {
  //TODO: check schema
  [questionID: QuestionID]: {
    [id: string]: IActionRulesSubLogicStatements
  }
}

export interface IActionRulesSkipLogicStatementValue {
  condition?: boolean
  target: string[]
}

export interface IActionRulesSkip {
  [id: string]: IActionRulesSkipLogicStatementValue[]
}

export interface IActionRulesShow {
  [id: string]: boolean
}

export interface IActionRulesHideText {
  [id: string]: IActionRulesSubLogicStatementValue
}

export interface IActionRules {
  sub?: IActionRulesSub
  fail?: {
    //TODO: fill or remove
  }
  hide_text?: IActionRulesHideText
  note?: {
    //TODO: fill or remove
  }
  redirect?: {
    //TODO: fill or remove
  }
  show?: IActionRulesShow
  skip?: IActionRulesSkip
}

export interface ISurveyFeatures {
  imageProtector: boolean
  hideOberig: boolean
  feedback?: boolean
  matrixStickyHeader?: boolean
}

export interface IProxyParams {
  [proxyParamKey: string]: unknown
}
export interface IAction {
  action?: ActionType
  mode?: SurveyMode
  action_proxy_params?: IProxyParams
  action_url?: string
  origin_url?: string
  redirect_url?: string
  aytm_domain?: string
  banner?: {
    type?: string
    url?: string
  }
  payload?: Record<string, unknown>
  data_values?: unknown
  status?: string
  data?: {
    questions?: IQuestionSchema[]
    survey?: {
      resptitle?: string
      end_text?: string
      side_text?: string
    }
    locale?: {
      aytm_locale: string
      survey_locale: string
      dict: ILocaleDict
    }
    time?: {
      elapsed: number
      loi: number
    }
    back?: {
      available: boolean
      enable: boolean
      isFirstBatch: boolean
    }
    rules?: IActionRules
    style?: IWidgetStyle
  }
  preview?: {
    navigation_options?: IPreviewModuleJumpToQuestion[]
    quotas?: IPreviewModuleChangeQuota[]
    hard_reset?: boolean
    locales?: IPreviewModuleLocale[]
    device?: string
  }
  features?: ISurveyFeatures
  urls?: ISessionUrls
  enableRestart?: boolean
  gdpr_status?: string
  end_text?: string
  interactions?: IInteractionsConfig
}

export interface IPVResponse {
  data: IAction
}

export interface IActionSubmitResponse {
  id: QuestionID
  response: QuestionSubmitResponse
  check_response?: QuestionCheckResponse
  log: ITimelineEvent[]
  interactions?: string
  durations: ITimelineDurations
}

export interface IActionComponentProps {
  action: IAction
}

export interface IActionComponentAPI {
  /**
   * @returns {boolean} true if next press is processed by action component (for example, switched question), false otherwise
   */
  tryNext(): boolean
  /**
   * @returns {boolean} true if next prev is processed by action component (for example, switched question), false otherwise (for example when there is no questions to come back to)
   */
  tryPrev(): boolean
  /**
   * Show validation errors, executed on disabled next button press
   */
  showValidation(): void
  /**
   * @type {IActionSubmitResponse[]} array of submit responses
   */
  get submitResponse(): IActionSubmitResponse[]
  /**
   * @type {IQuestionModel} current question model
   */
  get currentQuestionModel(): IQuestionModel
}
